import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import styles from './confirmationDialog.module.scss';

export default memo(function ConfirmationDialog(props) {
    const [t] = useTranslation(props.dictionary);

    return (
        <Dialog open={props.open} onClose={props.closeDialog}>
            <DialogTitle>{t(props.title)} {props.confirmationItem}?</DialogTitle>
            <DialogContent>
                <DialogContentText>{t(props.detail)}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button autoFocus className={styles.actionButton} onClick={props.closeDialog}>
                    {t(props.cancelText)}
                </Button>
                <Button className={styles.actionButton} onClick={props.confirm}>
                    {t(props.confirmText)}
                </Button>
            </DialogActions>
        </Dialog>
    );
}, (prevProps, nextProps) =>
        prevProps.open === nextProps.open &&
        prevProps.dictionary === nextProps.dictionary &&
        prevProps.confirmText === nextProps.confirmText &&
        prevProps.cancelText === nextProps.cancelText &&
        prevProps.title === nextProps.title &&
        prevProps.detail === nextProps.detail &&
        prevProps.confirmationItem === nextProps.confirmationItem
);
